import "./MobileNavigationFooter.scss"
import {Link, NavLink, useMatch} from "react-router";
import React, {useEffect, useState} from "react";
import {useUnitsState} from "../store/UnitsState";
import {IObject} from "../interfaces/IObject";
import {detectActive} from "../util/url";

export function MobileNavigationFooter() {

  const store = useUnitsState()

  const [object, setObject] = useState<IObject | null>(null);

  const match = useMatch("/storefront/:object_name/*");

  useEffect(() => {
    if (store.loading) return
    if (match && match.params.object_name !== 'fav' && match.params.object_name !== 'map') {
      const object = store.objects.find(o => o.name === match.params.object_name)
      if (object) {
        setObject(object);
        return;
      }
    }
    setObject(null);
  }, [match, store.loading]);

  function ObjectNavigation() {
    return <>
      <Link
        to="/storefront"
        className={detectActive('/storefront')}>
        <icon-houses></icon-houses>
        <label>Новобудови</label>
      </Link>
      <span className="footer-splitter"></span>
      <Link
        className={detectActive(`/storefront/${object?.name}`)}
        to={`/storefront/${object?.name}`}>
        <icon-house></icon-house>
        <label>Про проект</label>
      </Link>
      <NavLink to={`/storefront/${object?.name}/plan`}>
        <icon-floor-plan></icon-floor-plan>
        <label>Планування</label>
      </NavLink>
      <NavLink to={`/storefront/${object?.name}/map`}>
        <icon-map></icon-map>
        <label>На мапі</label>
      </NavLink>
      <span className="footer-splitter"></span>
      <NavLink to={`/storefront/${object?.name}/fav`}>
        <icon-heart></icon-heart>
        <label>Обране</label>
      </NavLink>
    </>
  }

  function TopNavigation() {
    return <>
      <Link
        to="/storefront"
        className={detectActive('/storefront')}>
        <icon-houses></icon-houses>
        <label>Новобудови</label>
      </Link>
      <span className="footer-splitter"></span>
      <NavLink to="/storefront/map">
        <icon-map></icon-map>
        <label>На мапі</label>
      </NavLink>
      <span className="footer-splitter"></span>
      <NavLink to="/storefront/fav">
        <icon-heart></icon-heart>
        <label>Обране</label>
      </NavLink>
    </>
  }

  return object ? <ObjectNavigation/> : <TopNavigation/>

}